import helpers from "@js/libs/helpers";

helpers.docReady(() => {

	let links = document.getElementById("Links");

	if (!links)  {
		return;
	}

	let timer;
	const images = [];
	let pointer = 0;

	helpers.qsa('.Link', (el, i) => {

		let src = el.querySelectorAll('img')[0].getAttribute('src');
		let alt = el.querySelectorAll('img')[0].getAttribute('alt');

		images.push({
			src,
			alt,
			el,
		});

		el.addEventListener('mouseover', () => {

			clearTimeout(timer);

			helpers.qsa('.Link', (el) => {
				helpers.removeClass(el, 'text-black');
			});

			swap(i);

		});

	});

	const image1 = document.getElementById("image1");
	const image2 = document.getElementById("image2");
	let image1Active = true;

	const swap = i => {

		let inImage;
		let outImage;

		if (image1Active) {
			inImage = image1;
			outImage = image2;
		} else {
			outImage = image1;
			inImage = image2;
		}

		let image;

		if (typeof i === 'undefined') {
			image = images[pointer];
		} else {
			image = images[i];
		}

		helpers.qsa('.Link', (el) => {
			helpers.removeClass(el, 'text-black');
		});

		helpers.addClass(image.el, 'text-black');

		inImage.src = image.src;
		inImage.alt = image.alt;

		helpers.addClass(inImage, 'FadeIn');
		helpers.removeClass(outImage, 'FadeIn');

		helpers.addClass(outImage, 'FadeOut');
		helpers.removeClass(inImage, 'FadeOut');

		pointer += 1;

		if (pointer >= images.length) {
			pointer = 0;
		}

		image1Active = !image1Active;
	};

	swap();

	// Swap images automatically
	timer = setInterval(() => {

		swap();

	}, 3000);


}, 'links');

